export default () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2715_6690)">
            <rect width="32" height="32" rx="7" fill="url(#paint0_linear_2715_6690)"/>
            <rect width="32" height="32" rx="7" fill="url(#paint1_linear_2715_6690)"/>
            <path d="M18 10V14.96C18 16.8266 17.136 18.5865 15.648 19.5465L12 22" stroke="#161B2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
            <linearGradient id="paint0_linear_2715_6690" x1="32" y1="-9.77778" x2="-8.62486" y2="-18.5013" gradientUnits="userSpaceOnUse">
                <stop stop-color="#01E2D6"/>
                <stop offset="1" stop-color="#0095FF"/>
            </linearGradient>
            <linearGradient id="paint1_linear_2715_6690" x1="32" y1="-9.77778" x2="-8.62486" y2="-18.5013" gradientUnits="userSpaceOnUse">
                <stop stop-color="#E2A601"/>
                <stop offset="1" stop-color="#FFFF00"/>
            </linearGradient>
            <clipPath id="clip0_2715_6690">
                <rect width="32" height="32" rx="7" fill="white"/>
            </clipPath>
        </defs>
    </svg>
)